import axios from "axios";

const ENV = "prod"

export async function api_postNewEliteEntry(data) {
	let url = `https://${ENV}.api.sugarcosmetics.com/marketing/${ENV}/postNewEliteEntry`;
	let headers = {
		"Content-Type": "application/json",
	};

	let body = { ...data };

	return postApi(url, body, headers);
}

export async function api_ImageUpload({ mime, name, image }) {
	let url = `https://${ENV}.api.sugarcosmetics.com/custom-dashboard/${ENV}/image-upload`;
	let headers = {
		"Content-Type": "application/json",
	};

	let body = {
		mime: mime,
		name: name,
		image: image,
	};

	return postApi(url, body, headers);
}

export function getApi(url, headers) {
	return new Promise(function (resolve, reject) {
		axios({
			method: "get",
			url: url,
			headers: headers,
		})
			.then((res) => {
				resolve(res);
			})
			.catch((err) => {
				console.log({ url, err });
				resolve(err?.response || err);
			});
	});
}

export function postApi(url, data, headers) {
	return new Promise(function (resolve, reject) {
		axios({
			method: "post",
			url: url,
			headers: headers,
			data: data,
		})
			.then((res) => {
				resolve(res);
			})
			.catch((err) => {
				console.log({ url, err });
				resolve(err?.response || err);
			});
	});
}
